export function isCategory<T extends string>(
  category?: string,
  categories: T[] = [],
): category is T {
  return !!category && categories.includes(category as any);
}
